import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import TitleCard from "@/components/feature/TitleCard";
import { trendingTitles } from "@/mocks/titles";

const tabs = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
] as const;

type TabKey = (typeof tabs)[number]["key"];

export default function TrendingSection() {
  const [tab, setTab] = useState<TabKey>("all");

  const list = useMemo(() => {
    const filtered = tab === "all" ? trendingTitles : trendingTitles.filter((item) => item.type === tab);
    return filtered.slice(0, 10);
  }, [tab]);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px]">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs tracking-[0.18em] text-accent-600">
              <span className="inline-block h-3 w-0.5 bg-accent-500"></span>
              热门推荐
            </p>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">大家最近都在看</h2>
            <p className="mt-2 text-sm text-foreground-600">按站内热度排序，每日更新</p>
          </div>
          <div className="flex items-center gap-1 self-start rounded-full bg-background-100 px-1 py-1">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`rounded-full px-4 py-1.5 text-xs whitespace-nowrap transition-colors cursor-pointer ${
                  tab === item.key
                    ? "bg-primary-800 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        {list.length === 0 ? (
          <p className="rounded-lg border border-background-200 bg-background-50 px-6 py-12 text-center text-sm text-foreground-500">
            暂无符合条件的影视作品
          </p>
        ) : (
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5 lg:grid-cols-5">
            {list.map((item) => (
              <TitleCard key={item.id} item={item} />
            ))}
          </div>
        )}

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category/movie/list"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-grid-line" aria-hidden="true"></i>
            浏览全部电影
          </Link>
          <Link
            to="/category/tv/list"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-list-check-2" aria-hidden="true"></i>
            浏览全部剧集
          </Link>
        </div>
      </div>
    </section>
  );
}